const Waypoint = window.Waypoint
import { select } from "@assets/scripts/utils";

export default function animateItem (selector, options = {}) {
    select(selector).forEach(item => {
        const animations = options.sectionAnimations.reduce((array, a) => {
            if(a.section === item.id) array.push(a.animation)
            return array
        }, [])

        new Waypoint({
            element: item,
            handler(dir) {
                if(dir !== 'down') return
                item.classList.add('animated')
                animations.forEach(a => {
                    a.go()
                })
                this.destroy()
            },
            offset: '80%'
        })
    })
}
